module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Published by"), _c('br'), _vm._v("\nGrub Street Publishing"), _c('br'), _vm._v("\n4 Rainham Close"), _c('br'), _vm._v("\nLondon"), _c('br'), _vm._v("\nSW11 6SS")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Copyright © Grub Street 2012"), _c('br'), _vm._v("\nCopyright text © Richard Pike 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('b', [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _c('br'), _vm._v("\nPike, Richard, 1943-"), _c('br'), _vm._v("\n   Alfie's War: A Fleet Air Arm Officer's exciting exploits on"), _c('br'), _vm._v("\n   HMS "), _c('i', [_vm._v("Illustrious")]), _vm._v(", in Greece and Crete."), _c('br'), _vm._v("\n   1. Sutton, A. W. F. (Alan William Frank)"), _c('br'), _vm._v("\n   2. Great Britain. Royal Navy. Fleet Air Arm–History."), _c('br'), _vm._v("\n   3. World War, 1939-1945–Naval operations, British."), _c('br'), _vm._v("\n   I. Title"), _c('br'), _vm._v("\n   940.5'45'941'092-dc23"), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("ISBN-13: 9781908117410"), _c('br'), _vm._v("\n   EPUB ISBN: 9781909166332")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication may be"), _c('br'), _vm._v("\nreproduced, stored in a retrieval system, or transmitted"), _c('br'), _vm._v("\nin any form or by any means electronic, mechanical,"), _c('br'), _vm._v("\nphotocopying, recording, or otherwise, without the prior"), _c('br'), _vm._v("\npermission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Edited by Sophie Campbell")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Book design and artwork by Roy Platten, Eclipse"), _c('br')]), _c('a', {
    attrs: {
      "href": "mailto:roy.eclipse@btopenworld.com"
    }
  }, [_vm._v("roy.eclipse@btopenworld.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Printed and bound by MPG Ltd, Bodmin, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Grub Street Publishing uses only FSC (Forest Stewardship"), _c('br'), _vm._v("\nCouncil) paper for its books.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Publisher’s Note: Captain A W F ‘Alfie’ Sutton referred to himself"), _c('br'), _vm._v("\nas the lieutenant, and we have kept this style throughout.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0